import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { axiosInstance } from '../../axios/axiosHandler';
import { EndPoints } from '../../axios/endPoints';
import { authHeader } from '../auth-slice/auth-slice';

export interface SVMPredictBodyParams {
    sex: number,
    age: number,
    weight: number,
    height: number,
    stoneSizeInMilimeters: number,
    stonePosition: number,
    fever: number,
    symptomsDurationInHours: number,
    previousStoneExplusion: number,
    previousUrologicTreatment: number
}

interface ImageParams {
    stoneSizeInMilimeters: number,
    stonePosition: number
}

export interface PredictionInterface {
    predictionSuccess: boolean,
    ableToExpel: number,
    probabilityToExpel: number,
    maximalStoneSizeToExpel: number,
    maximalStoneSizeProbabilityToExpel: number,
    imageParams: ImageParams
}

interface SVMPredictResponse {
    success: boolean,
    message: string,
    result: PredictionInterface
}

export const svmPredict = createAsyncThunk(
  'SVMPredict',
  async (body : SVMPredictBodyParams, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        EndPoints.SVM_PREDICT,
        body,
        authHeader()
      );
      return await  response.data as SVMPredictResponse;
    } catch (error) {
      return thunkAPI.rejectWithValue(null);
    }
  }
);

export const predictionSlice = createSlice({
    name: 'predictions',
    initialState: {
        loadingPredictions: false as boolean,
        predictionResults: null as PredictionInterface | null,
        previewPredictionParameters: false as boolean,
        predictionParameters: null as SVMPredictBodyParams | null
    },
    reducers: {
        previewPredictionParametersHandler: (state, action) => {
            state.previewPredictionParameters = action.payload;
        },
        setPreviewParameters: (state, action) => {
            state.predictionParameters = action.payload;
        },
        handleRemovePredictionResults: (state) => {
            state.predictionResults = null;
            state.predictionParameters = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(svmPredict.pending, (state, action) => { 
            state.loadingPredictions = true;
        })
        builder.addCase(svmPredict.fulfilled, (state, action) => { 
            state.loadingPredictions = false;
            if(action.payload.success) {
                state.predictionResults = action.payload.result;
            }
        })
        builder.addCase(svmPredict.rejected, (state, action) => { 
            state.loadingPredictions = false;
        })
    },
});

export const { previewPredictionParametersHandler, setPreviewParameters, handleRemovePredictionResults } = predictionSlice.actions;

export const predictionsSelector = (state: RootState) => state.predictions;
